module.exports = __webpack_public_path__ + "media/images/homepage/reason-3-302fdee768fc8114d3c9d61e3869273a.png";